export default __webpack_public_path__ + "static/media/sunday.fab70ff2.png";